import { api } from "@/lib/api";

/**
 * Restaurant service – abstracts data fetching so the future
 * Feaststar production API can be swapped in without component changes.
 */
export const restaurantService = {
  async listRestaurants(opts = {}) {
    const { data } = await api.get("/restaurants", { params: opts });
    return data;
  },

  async getRestaurantById(id) {
    const { data } = await api.get(`/restaurants/${id}`);
    return data;
  },

  async searchRestaurants(query) {
    const q = (query || "").trim();
    if (!q) return { items: [], count: 0, query: "" };
    const { data } = await api.get("/restaurants/search", { params: { q } });
    return data;
  },

  async trackRestaurantOriginSelection(payload) {
    const { data } = await api.post("/restaurant-origin", payload);
    return data;
  },
};

export const partnerLeadService = {
  async createLead(payload) {
    const { data } = await api.post("/partner-leads", payload);
    return data;
  },
};

export const waitlistService = {
  async signup(payload) {
    const { data } = await api.post("/waitlist", payload);
    return data;
  },
};
